(function(){
  // Product gallery thumbnails
  document.querySelectorAll('[data-thumb]').forEach(function(b){
    b.addEventListener('click',function(){
      var main=document.getElementById('mainImg');
      if(main){main.src=b.dataset.src;main.alt=b.dataset.alt||''}
      document.querySelectorAll('[data-thumb]').forEach(function(x){x.setAttribute('aria-pressed',x===b?'true':'false')});
    });
  });
  // Variant selector updates the price shown
  var sel=document.getElementById('variantSelect');
  if(sel){
    sel.addEventListener('change',function(){
      var o=sel.options[sel.selectedIndex],p=document.getElementById('priceNow'),c=document.getElementById('priceWas');
      if(p&&o.dataset.price)p.textContent=o.dataset.price;
      if(c){c.textContent=o.dataset.was||'';c.hidden=!o.dataset.was}
      if(o.dataset.img){
        var m=document.getElementById('mainImg');
        if(m){m.src=o.dataset.img;m.removeAttribute('srcset');m.alt=o.dataset.alt||''}
        document.querySelectorAll('[data-thumb]').forEach(function(x){x.setAttribute('aria-pressed',x.dataset.src===o.dataset.img?'true':'false')});
      }
    });
  }
  // Cart: update on quantity change
  document.querySelectorAll('[data-qty]').forEach(function(i){
    i.addEventListener('change',function(){var f=i.closest('form');if(f){var b=f.querySelector('[name=update]');if(b)b.click();else f.submit()}});
  });
  // Sort select
  var s=document.getElementById('sortBy');
  if(s){s.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',s.value);u.searchParams.delete('page');location.href=u.toString()})}
  // Password recovery toggle
  var rb=document.getElementById('recoverShow'),rh=document.getElementById('recoverHide'),rf=document.getElementById('recoverBox'),lf=document.getElementById('loginBox');
  if(rb&&rf&&lf){rb.addEventListener('click',function(e){e.preventDefault();rf.hidden=false;lf.hidden=true});rh.addEventListener('click',function(e){e.preventDefault();rf.hidden=true;lf.hidden=false});if(location.hash==='#recover'){rf.hidden=false;lf.hidden=true}}
})();
